// extracted by mini-css-extract-plugin
module.exports = {"edit":"zCA_OdZGEfdsAUeCDosOC"};